import CourseSubject from './CourseSubject';

export default CourseSubject;
